import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
  type QueryKey,
} from '@tanstack/react-query';
import service from '../service';
import type { Redemption } from '../types/redemption';

type RedemptionsResponse = {
  data: Redemption[];
  meta?: {
    total: number;
  };
};

type DefaultError = unknown;

export const redemptionQueryKeys = {
  all: ['redemptions'] as const,
  lists: () => [...redemptionQueryKeys.all, 'list'] as const,
  list: (params: Record<string, string>) =>
    [...redemptionQueryKeys.lists(), params] as const,
};

type UseRedemptionsParams = {
  searchParams?: Record<string, string>;
  enabled?: boolean;
};

export function useRedemptions<
  TData = RedemptionsResponse,
  TError = DefaultError,
>(
  { searchParams = {}, enabled = true }: UseRedemptionsParams = {},
  options?: Omit<
    UseQueryOptions<RedemptionsResponse, TError, TData, QueryKey>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
): UseQueryResult<TData, TError> {
  const queryKey: QueryKey = redemptionQueryKeys.list(searchParams);

  return useQuery<RedemptionsResponse, TError, TData>({
    queryKey,
    enabled,
    queryFn: async () => service.getRedemptions(searchParams),
    ...(options as any),
  });
}
